module.exports = function getResource (label) {
    const resources = {
        addPromoCode: 'Ajouter un code promotionnel',
        enterPromoRewards: 'Saisir la promo et les récompenses',
        addPromoOrRewardCode: 'Add promo or reward code'
    };
    return resources[label];
};
